import BaseEntityNew from 'client/components/core/BaseEntity/BaseEntityNew'
import usePresentPage, { selectors } from 'client/hooks/usePresentPage'
import { useWebsiteSettings } from 'client/store'
import { EntityProps } from 'client/types'
import React from 'react'
import { getWebsiteLocales } from 'src/editor/store/website-settings/website-settings-selector'
import { CommonWebsiteLanguageSwitcher } from 'src/shared/entities/website-language-switcher'
import { WebsiteLanguageSwitcherInterface } from 'src/shared/types/entities/website-language-switcher-interface'

export const WebsiteLanguageSwitcher = ({
  entity,
  isMoveUpAllowed,
  isMoveDownAllowed,
}: EntityProps<WebsiteLanguageSwitcherInterface>) => {
  const websiteLocales = useWebsiteSettings(getWebsiteLocales)
  const locale = usePresentPage(selectors.getPageLocale)
  return (
    <BaseEntityNew
      entity={entity}
      isMoveUpAllowed={isMoveUpAllowed}
      isMoveDownAllowed={isMoveDownAllowed}
    >
      <CommonWebsiteLanguageSwitcher
        websiteLocales={websiteLocales}
        currentLanguage={locale}
        skipLinksGeneration
        {...entity}
      />
    </BaseEntityNew>
  )
}
